import React from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import "@/App.css";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import MusicToggle from "@/components/MusicToggle";
import Home from "@/pages/Home";
import About from "@/pages/About";
import Research from "@/pages/Research";
import Shop from "@/pages/Shop";
import SubmitPhoto from "@/pages/SubmitPhoto";
import Radar from "@/pages/Radar";
import SpcOutlook from "@/pages/SpcOutlook";
import Apply from "@/pages/Apply";
import Contact from "@/pages/Contact";
import Events from "@/pages/Events";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";
import Chat from "@/pages/Chat";
import ChatLogin from "@/pages/ChatLogin";
import ChatRegister from "@/pages/ChatRegister";
import ChatAuthCallback from "@/pages/ChatAuthCallback";
import { AuthProvider } from "@/context/AuthContext";
import { ChatAuthProvider } from "@/context/ChatAuthContext";

function PublicLayout({ children }) {
  return (
    <>
      <Navbar />
      <main>{children}</main>
      <Footer />
    </>
  );
}

function AppRouter() {
  const location = useLocation();
  // Detect Emergent OAuth callback fragment synchronously (must be checked before Routes)
  if (location.hash?.includes("session_id=")) {
    return <ChatAuthCallback />;
  }
  const isPublicPage = !["/login", "/admin"].includes(location.pathname) && !location.pathname.startsWith("/chat");
  return (
    <>
      <Routes>
        <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
        <Route path="/about" element={<PublicLayout><About /></PublicLayout>} />
        <Route path="/research" element={<PublicLayout><Research /></PublicLayout>} />
        <Route path="/radar" element={<PublicLayout><Radar /></PublicLayout>} />
        <Route path="/spc" element={<PublicLayout><SpcOutlook /></PublicLayout>} />
        <Route path="/shop" element={<PublicLayout><Shop /></PublicLayout>} />
        <Route path="/submit-photo" element={<PublicLayout><SubmitPhoto /></PublicLayout>} />
        <Route path="/apply" element={<PublicLayout><Apply /></PublicLayout>} />
        <Route path="/contact" element={<PublicLayout><Contact /></PublicLayout>} />
        <Route path="/events" element={<PublicLayout><Events /></PublicLayout>} />
        <Route path="/login" element={<Login />} />
        <Route path="/admin" element={<Admin />} />
        <Route path="/chat" element={<Chat />} />
        <Route path="/chat-login" element={<ChatLogin />} />
        <Route path="/chat-register" element={<ChatRegister />} />
        <Route path="*" element={<PublicLayout><Home /></PublicLayout>} />
      </Routes>
      {isPublicPage && <MusicToggle />}
    </>
  );
}

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <ChatAuthProvider>
          <BrowserRouter>
            <Toaster
              position="top-center"
              theme="dark"
              toastOptions={{
                style: {
                  background: "#0A1224",
                  border: "1px solid rgba(0,240,255,0.25)",
                  color: "#F4F6FF",
                  fontFamily: "'Manrope', sans-serif",
                },
              }}
            />
            <AppRouter />
          </BrowserRouter>
        </ChatAuthProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
